module.exports = __webpack_public_path__ + "aed9e5c0.png";